var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-loader"},[_c('Modal',{attrs:{"container-style":{
      width: '200px',
      margin: 'auto',
    }}},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('LoaderPacman',{attrs:{"slot":"body"},slot:"body"}),_vm._v(" "),_c('div',{staticClass:"modal-loader__footer",attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n      "+_vm._s(_vm.loadingText)+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }